import { DocketEntryTypeNotificationsMutations } from './partials/notifications'

export const DocketEntryTypeMutations = {
  ...DocketEntryTypeNotificationsMutations,

  setDocketEntryTypes: (state, payload) => { state.docketEntryTypes = payload },
}
